<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right" class="el-breadcrumb">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户设置</el-breadcrumb-item>
            <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="5">
                    <el-input placeholder="请输入用户名" v-model="queryInfo.username" clearable @clear="getUserList()">
                    </el-input>
                </el-col>
                <el-col :span="5">
                    <el-input placeholder="请输入邮箱" v-model="queryInfo.email" clearable @clear="getUserList()">
                    </el-input>
                </el-col>
                <el-col :span="5">
                    <el-input placeholder="请输入手机号" v-model="queryInfo.phone" clearable @clear="getUserList()">
                    </el-input>
                </el-col>
                <!--搜索按钮-->
                <el-col :span="4">
                    <el-button type="primary" icon="el-icon-search" @click="getUserList">{{$t('common.search')}}</el-button>
                </el-col>
            </el-row>
            <!--用户列表区域-->
            <el-table :data="userList.records" border stripe v-loading="tableLoading">
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column label="用户名" prop="username"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column label="邮箱" prop="email"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" ></el-table-column>
                <el-table-column label="查询权限设置" >
                    <template slot-scope="scope">
                    <!--<template slot-scope="scope">-->
                        <!--<el-checkbox-group @change="stateChange(scope.row)" v-model="scope.row.setState">-->
                            <!--<el-checkbox :label="0">全部</el-checkbox>-->
                            <!--<el-checkbox :label="1">自己使用该设备的其他用户数据</el-checkbox>-->
                            <!--<el-checkbox :label="2">自己</el-checkbox>-->
                        <!--</el-checkbox-group>-->
                    <!--</template>-->
                    <el-tooltip effect="dark" content="设置" placement="top" :enterable="false">
                        <el-button type="primary" icon="el-icon-setting" size="mini"
                                   @click="roleEditDialog(scope.row)"></el-button>
                    </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="userList.total">
            </el-pagination>
        </el-card>
        <!--设置权限-->
        <el-dialog
                title="设置权限"
                :visible.sync="DialogVisible"
                width="50%">
            <!--内容主体区域-->
            <el-form :model="form" :rules="form" ref="addCategoryRef" label-width="70px">
                <el-divider content-position="left">后台配置</el-divider>
                <el-form-item label="">
                    <el-checkbox-group v-model="form.setState">
                        <el-checkbox label="0">全部</el-checkbox>
                        <el-checkbox label="1">自己</el-checkbox>
                        <el-checkbox label="2">使用该设备的其他用户数据</el-checkbox>
                        <el-checkbox label="3">算法用参数是否显示</el-checkbox>
                        <el-checkbox label="4">删除历史数据权限</el-checkbox>
                        <el-checkbox label="5">设备传递参数是否显示</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!--<el-divider content-position="left">系统配置</el-divider>-->
                <!--<el-form-item label="">-->
                    <!--<el-checkbox-group v-model="form.setMenu">-->
                        <!--<el-checkbox v-for="menu in menuList" :label="menu.id" :key="menu.id">{{menu.menuName}}</el-checkbox>-->
                    <!--</el-checkbox-group>-->
                <!--</el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateChange">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "userList",
        data() {
            return {
                menuList:[],
                form: {
                    setState: [],
                    setMenu:[],
                    id:''
                },
                id:'',
                DialogVisible:false,
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10
                },
                roleId:'',
                userList: {
                    records: [],
                    total: 0,
                },
                // 添加的用户对象
                addUserForm: {
                    state: 1
                },
                // 修改的用户对象
                editUserForm: {},
                // 添加分类的验证规则
                addUserRules: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 5, max: 15, message: '长度在 5 到 15 个字符', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 5, max: 15, message: '长度在 5 到 15 个字符', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '请输入邮箱', trigger: 'blur'},
                        {type: 'email', message: '请输入正确格式的邮箱地址', trigger: 'blur'}
                    ], phone:[
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { validator:function(rule,value,callback){
                                if(/^1[34578]\d{9}$/.test(value) == false){
                                    callback(new Error("请输入正确的手机号"));
                                }else{
                                    callback();
                                }
                            }, trigger: 'blur'
                        },
                    ],
                },
                // 控制添加用户弹框的显示和隐藏
                addDialogVisible: false,
                // 控制修改用户弹框的显示和隐藏
                editDialogVisible: false,
                options: [
                    {label: '正常', value: 1},
                    {label: '禁用', value: 0}
                ],
                roleOptions:[],
                tableLoading:false
            }
        },
        created() {
            this.getUserList();
            this.getAllRoles();
            this.getMenuList()
        },
        methods: {
            async getMenuList() {
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/appedition/getAppMenu`, {});
                if (res.code !== 1) return this.$message.error("获取菜单列表失败！");
                this.menuList = res.data
            },
            async getUserList() {
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/api/user/selectPage`, this.queryInfo);
                if (res.code !== 1) return this.$message.error("获取用户列表失败！");
                this.tableLoading = false
                this.userList.records = res.data.records;
                this.userList.total = res.data.total
            },
            async showAddDialog() {
                this.addDialogVisible = true;
            },
            async stateChange(info) {
                let roleId=null
                if(this.form.setMenu.join().split(',').length==2){
                    roleId=10
                }
                if(this.form.setMenu.join().split(',').length==1){
                    if(this.form.setMenu.join()=='ff80808177141bd4017719e99ff10044'){
                        roleId=9
                    }else{
                        roleId=8
                    }
                }
                let {data: res} = await this.$http.post(`/api/user/saveOrUpdate`, {roleId:roleId,setMenu:this.form.setMenu.join(),id:this.form.id,setState:this.form.setState.join()});
                if (res.code !== 1) {
                    info.setState = !info.setState;
                    return this.$message.error(res.msg)
                }
                this.$message.success("更新查询权限成功")
                this.DialogVisible = false;
            },
            async showEditDialog(id) {
                let user = {};
                user.id = id;
                const {data: res} = await this.$http.post(`/api/user/getById`, user);
                if (res.code !== 1) {
                    this.$message.error(res.msg)
                }
                this.editUserForm = res.data;
                this.editDialogVisible = true;
            },
            async roleEditDialog(row){
                this.form.id=row.id;
                this.form.setState = row.setState.split('')
                this.form.setMenu = row.setMenu.split(',')
                console.log(this.form.setMenu )
                this.DialogVisible = true;
            },
            // 获取所有权限
            async getAllRoles(){
                const {data: res} = await this.$http.post(`/api/role/select`, {});
                if (res.code !== 1) {
                    this.$message.error(res.msg)
                }
                for(let i=0;i<res.data.length;i++){
                    let a={label:res.data[i].roleName,value:res.data[i].roleUuid}
                    this.roleOptions.push(a)
                }
            },
            async removeUserById(id) {
                // 弹框询问用户是否删除分类
                await this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除分类
                    const user = {
                        ids: []
                    };
                    user.ids[0] = id;
                    const {data: res} = await this.$http.post(`/api/user/removeById`, user);
                    if (res.code !== 1) return this.$message.error("删除用户失败");
                    this.$message.success("删除用户成功");
                    // 重新获取分类列表
                    this.getUserList();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getUserList()
            },
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getUserList()
            },
            addDialogClosed() {
                this.$refs['addUserRef'].resetFields();
            },
            addUser() {
                this.$refs.addUserRef.validate(async valid => {
                    if (!valid) return;
                    // 发起添加用户的网络请求
                    const {data: res} = await this.$http.post('/api/user/saveOrUpdate', this.addUserForm);
                    if (res.code !== 1) {
                        return this.$message.error(res.msg)
                    }
                    this.$message.success("添加用户成功");
                    // 隐藏添加分类对话框
                    this.addDialogVisible = false;
                    // 重新获取分类列表
                    this.getUserList();
                })
            },
            editUserInfo() {
                this.$refs.addCategoryRef.validate(async valid => {
                    if (!valid) return;
                    // 发起修改用户的网络请求
                    const {data: res} = await this.$http.post(`/api/user/saveOrUpdate`, this.editUserForm);
                    if (res.code !== 1) {
                        return this.$message.error(res.msg)
                    }
                    this.$message.success("修改用户成功");
                    // 隐藏添加分类对话框
                    this.editDialogVisible = false;
                    // 重新获取分类列表
                    this.getUserList();
                })
            },
            async roleUserInfo(){
                // 发起绑定角色的网络请求
                const {data: res} = await this.$http.post(`/api/user/saveOrUpdate`, {roleId:this.roleId,id:this.id});
                if (res.code !== 1) {
                    return this.$message.error(res.msg)
                }
                this.$message.success("绑定成功");
                // 隐藏绑定角色对话框
                this.DialogVisible = false;
                // 重新获取分类列表
                this.getUserList();
            }
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
